//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.3]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AcceptanceCriteriaStatus } from './enums/acceptance-criteria-status.enum';
import { AcceptanceCriteriaType } from './enums/acceptance-criteria-type.enum';
import { AutoMatchStrategy } from './enums/auto-match-strategy.enum';
import { CategoryLineOfBusinessEnum } from './enums/category-line-of-business-enum.enum';
import { DocumentTypeLevelType } from './enums/document-type-level-type.enum';
import { FacilityCompleteStatus } from './enums/facility-complete-status.enum';
import { SortDirectionEnum } from './enums/sort-direction-enum.enum';
import { API_BASE_URL } from './misc/api-base-url.token';
import { blobToText } from './misc/blob-to-text.function';
import { FileParameter } from './misc/file-parameter.model';
import { FileResponse } from './misc/file-response.model';
import { throwException } from './misc/throw-exception.function';
import { ClientPortalVisibilitySettingsDto } from './models/client-portal-visibility-settings-dto.model';
import { ClientPortalVisibilityUpdateDto } from './models/client-portal-visibility-update-dto.model';
import { ComplianceFacilityBulkEditDto } from './models/compliance-facility-bulk-edit-dto.model';
import { ComplianceFacilityDto } from './models/compliance-facility-dto.model';
import { DocDueDateDto } from './models/doc-due-date-dto.model';
import { FacilityAutoMatchSettingsDto } from './models/facility-auto-match-settings-dto.model';
import { FacilityAutoMatchSettingsViewModel } from './models/facility-auto-match-settings-view-model.model';
import { FacilityDocDueDatesDto } from './models/facility-doc-due-dates-dto.model';
import { KeyValueDto } from './models/key-value-dto.model';
import { PagingTokenOfComplianceFacilityDto } from './models/paging-token-of-compliance-facility-dto.model';
import { ProblemDetails } from './models/problem-details.model';
import { ProfileRequirementsDto } from './models/profile-requirements-dto.model';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class FacilitiesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getFacilities(filter_Id: number | null | undefined, filter_Name: string | null | undefined, filter_CompleteStatus: FacilityCompleteStatus[] | null | undefined, filter_LineOfBusiness: string | null | undefined, filter_LiaisonName: string | null | undefined, filter_AccountManager: string | null | undefined, filter_QmAssociationId: number | null | undefined, filter_QmAssociation: string | null | undefined, filter_HospitalSystem: string | null | undefined, filter_ContractGroup: string | null | undefined, filter_UpdatedDate: string | null | undefined, filter_CredentialingSpecialistId: (number | null)[] | null | undefined, filter_StateId: number | null | undefined, filter_BrandId: number | null | undefined, filter_VmsMsp: number[] | null | undefined, filter_Software: string | null | undefined, filter_ContractGroupId: number | null | undefined, filter_AutoMatchStrategy: AutoMatchStrategy[] | null | undefined, pageSize: number | undefined, skip: number | undefined, sort_Field: string | null | undefined, sort_Type: SortDirectionEnum | undefined, paginated: boolean | undefined): Observable<PagingTokenOfComplianceFacilityDto> {
        let url_ = this.baseUrl + "/AyaNova/compliance/Facilities?";
        if (filter_Id !== undefined && filter_Id !== null)
            url_ += "Filter.Id=" + encodeURIComponent("" + filter_Id) + "&";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_CompleteStatus !== undefined && filter_CompleteStatus !== null)
            filter_CompleteStatus && filter_CompleteStatus.forEach(item => { url_ += "Filter.CompleteStatus=" + encodeURIComponent("" + item) + "&"; });
        if (filter_LineOfBusiness !== undefined && filter_LineOfBusiness !== null)
            url_ += "Filter.LineOfBusiness=" + encodeURIComponent("" + filter_LineOfBusiness) + "&";
        if (filter_LiaisonName !== undefined && filter_LiaisonName !== null)
            url_ += "Filter.LiaisonName=" + encodeURIComponent("" + filter_LiaisonName) + "&";
        if (filter_AccountManager !== undefined && filter_AccountManager !== null)
            url_ += "Filter.AccountManager=" + encodeURIComponent("" + filter_AccountManager) + "&";
        if (filter_QmAssociationId !== undefined && filter_QmAssociationId !== null)
            url_ += "Filter.QmAssociationId=" + encodeURIComponent("" + filter_QmAssociationId) + "&";
        if (filter_QmAssociation !== undefined && filter_QmAssociation !== null)
            url_ += "Filter.QmAssociation=" + encodeURIComponent("" + filter_QmAssociation) + "&";
        if (filter_HospitalSystem !== undefined && filter_HospitalSystem !== null)
            url_ += "Filter.HospitalSystem=" + encodeURIComponent("" + filter_HospitalSystem) + "&";
        if (filter_ContractGroup !== undefined && filter_ContractGroup !== null)
            url_ += "Filter.ContractGroup=" + encodeURIComponent("" + filter_ContractGroup) + "&";
        if (filter_UpdatedDate !== undefined && filter_UpdatedDate !== null)
            url_ += "Filter.UpdatedDate=" + encodeURIComponent("" + filter_UpdatedDate) + "&";
        if (filter_CredentialingSpecialistId !== undefined && filter_CredentialingSpecialistId !== null)
            filter_CredentialingSpecialistId && filter_CredentialingSpecialistId.forEach(item => { url_ += "Filter.CredentialingSpecialistId=" + encodeURIComponent("" + item) + "&"; });
        if (filter_StateId !== undefined && filter_StateId !== null)
            url_ += "Filter.StateId=" + encodeURIComponent("" + filter_StateId) + "&";
        if (filter_BrandId !== undefined && filter_BrandId !== null)
            url_ += "Filter.BrandId=" + encodeURIComponent("" + filter_BrandId) + "&";
        if (filter_VmsMsp !== undefined && filter_VmsMsp !== null)
            filter_VmsMsp && filter_VmsMsp.forEach(item => { url_ += "Filter.VmsMsp=" + encodeURIComponent("" + item) + "&"; });
        if (filter_Software !== undefined && filter_Software !== null)
            url_ += "Filter.Software=" + encodeURIComponent("" + filter_Software) + "&";
        if (filter_ContractGroupId !== undefined && filter_ContractGroupId !== null)
            url_ += "Filter.ContractGroupId=" + encodeURIComponent("" + filter_ContractGroupId) + "&";
        if (filter_AutoMatchStrategy !== undefined && filter_AutoMatchStrategy !== null)
            filter_AutoMatchStrategy && filter_AutoMatchStrategy.forEach(item => { url_ += "Filter.AutoMatchStrategy=" + encodeURIComponent("" + item) + "&"; });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (sort_Field !== undefined && sort_Field !== null)
            url_ += "Sort.Field=" + encodeURIComponent("" + sort_Field) + "&";
        if (sort_Type === null)
            throw new Error("The parameter 'sort_Type' cannot be null.");
        else if (sort_Type !== undefined)
            url_ += "Sort.Type=" + encodeURIComponent("" + sort_Type) + "&";
        if (paginated === null)
            throw new Error("The parameter 'paginated' cannot be null.");
        else if (paginated !== undefined)
            url_ += "Paginated=" + encodeURIComponent("" + paginated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFacilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFacilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingTokenOfComplianceFacilityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingTokenOfComplianceFacilityDto>;
        }));
    }

    protected processGetFacilities(response: HttpResponseBase): Observable<PagingTokenOfComplianceFacilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingTokenOfComplianceFacilityDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getComplianceFacility(id: number): Observable<ComplianceFacilityDto> {
        let url_ = this.baseUrl + "/AyaNova/compliance/Facilities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetComplianceFacility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetComplianceFacility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComplianceFacilityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComplianceFacilityDto>;
        }));
    }

    protected processGetComplianceFacility(response: HttpResponseBase): Observable<ComplianceFacilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ComplianceFacilityDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFacilityRequirements(id: number, clob: CategoryLineOfBusinessEnum, filter_RequirementId: number | null | undefined, filter_RequirementName: string | null | undefined, filter_TaskType: number[] | null | undefined, filter_ClientPortalVisibility: boolean | null | undefined, filter_RequirementLevel: DocumentTypeLevelType[] | null | undefined, filter_QualificationSettingsLevel: DocumentTypeLevelType[] | null | undefined, filter_LinesOfBusiness: number[] | null | undefined, filter_IsDefault: boolean | null | undefined, filter_ExpirationRequired: boolean | null | undefined, filter_RequirementDescription: DocumentTypeLevelType[] | null | undefined, filter_ExternalRequirementDescription: DocumentTypeLevelType[] | null | undefined, filter_CategoryLineOfBusinessId: number[] | null | undefined, filter_AcceptanceCriteriaType: AcceptanceCriteriaType[] | null | undefined, filter_AcceptanceCriteriaStatus: AcceptanceCriteriaStatus[] | null | undefined, pageSize: number | undefined, skip: number | undefined, sort_Field: string | null | undefined, sort_Type: SortDirectionEnum | undefined, paginated: boolean | undefined): Observable<ProfileRequirementsDto[]> {
        let url_ = this.baseUrl + "/AyaNova/compliance/Facilities/{id}/requirements/{clob}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (clob === undefined || clob === null)
            throw new Error("The parameter 'clob' must be defined.");
        url_ = url_.replace("{clob}", encodeURIComponent("" + clob));
        if (filter_RequirementId !== undefined && filter_RequirementId !== null)
            url_ += "Filter.RequirementId=" + encodeURIComponent("" + filter_RequirementId) + "&";
        if (filter_RequirementName !== undefined && filter_RequirementName !== null)
            url_ += "Filter.RequirementName=" + encodeURIComponent("" + filter_RequirementName) + "&";
        if (filter_TaskType !== undefined && filter_TaskType !== null)
            filter_TaskType && filter_TaskType.forEach(item => { url_ += "Filter.TaskType=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ClientPortalVisibility !== undefined && filter_ClientPortalVisibility !== null)
            url_ += "Filter.ClientPortalVisibility=" + encodeURIComponent("" + filter_ClientPortalVisibility) + "&";
        if (filter_RequirementLevel !== undefined && filter_RequirementLevel !== null)
            filter_RequirementLevel && filter_RequirementLevel.forEach(item => { url_ += "Filter.RequirementLevel=" + encodeURIComponent("" + item) + "&"; });
        if (filter_QualificationSettingsLevel !== undefined && filter_QualificationSettingsLevel !== null)
            filter_QualificationSettingsLevel && filter_QualificationSettingsLevel.forEach(item => { url_ += "Filter.QualificationSettingsLevel=" + encodeURIComponent("" + item) + "&"; });
        if (filter_LinesOfBusiness !== undefined && filter_LinesOfBusiness !== null)
            filter_LinesOfBusiness && filter_LinesOfBusiness.forEach(item => { url_ += "Filter.LinesOfBusiness=" + encodeURIComponent("" + item) + "&"; });
        if (filter_IsDefault !== undefined && filter_IsDefault !== null)
            url_ += "Filter.IsDefault=" + encodeURIComponent("" + filter_IsDefault) + "&";
        if (filter_ExpirationRequired !== undefined && filter_ExpirationRequired !== null)
            url_ += "Filter.ExpirationRequired=" + encodeURIComponent("" + filter_ExpirationRequired) + "&";
        if (filter_RequirementDescription !== undefined && filter_RequirementDescription !== null)
            filter_RequirementDescription && filter_RequirementDescription.forEach(item => { url_ += "Filter.RequirementDescription=" + encodeURIComponent("" + item) + "&"; });
        if (filter_ExternalRequirementDescription !== undefined && filter_ExternalRequirementDescription !== null)
            filter_ExternalRequirementDescription && filter_ExternalRequirementDescription.forEach(item => { url_ += "Filter.ExternalRequirementDescription=" + encodeURIComponent("" + item) + "&"; });
        if (filter_CategoryLineOfBusinessId !== undefined && filter_CategoryLineOfBusinessId !== null)
            filter_CategoryLineOfBusinessId && filter_CategoryLineOfBusinessId.forEach(item => { url_ += "Filter.CategoryLineOfBusinessId=" + encodeURIComponent("" + item) + "&"; });
        if (filter_AcceptanceCriteriaType !== undefined && filter_AcceptanceCriteriaType !== null)
            filter_AcceptanceCriteriaType && filter_AcceptanceCriteriaType.forEach(item => { url_ += "Filter.AcceptanceCriteriaType=" + encodeURIComponent("" + item) + "&"; });
        if (filter_AcceptanceCriteriaStatus !== undefined && filter_AcceptanceCriteriaStatus !== null)
            filter_AcceptanceCriteriaStatus && filter_AcceptanceCriteriaStatus.forEach(item => { url_ += "Filter.AcceptanceCriteriaStatus=" + encodeURIComponent("" + item) + "&"; });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (sort_Field !== undefined && sort_Field !== null)
            url_ += "Sort.Field=" + encodeURIComponent("" + sort_Field) + "&";
        if (sort_Type === null)
            throw new Error("The parameter 'sort_Type' cannot be null.");
        else if (sort_Type !== undefined)
            url_ += "Sort.Type=" + encodeURIComponent("" + sort_Type) + "&";
        if (paginated === null)
            throw new Error("The parameter 'paginated' cannot be null.");
        else if (paginated !== undefined)
            url_ += "Paginated=" + encodeURIComponent("" + paginated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFacilityRequirements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFacilityRequirements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileRequirementsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileRequirementsDto[]>;
        }));
    }

    protected processGetFacilityRequirements(response: HttpResponseBase): Observable<ProfileRequirementsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProfileRequirementsDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getClientPortalNetworkVisibility(id: number): Observable<ClientPortalVisibilitySettingsDto> {
        let url_ = this.baseUrl + "/AyaNova/compliance/Facilities/{id}/client-portal-visibility";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClientPortalNetworkVisibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClientPortalNetworkVisibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientPortalVisibilitySettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientPortalVisibilitySettingsDto>;
        }));
    }

    protected processGetClientPortalNetworkVisibility(response: HttpResponseBase): Observable<ClientPortalVisibilitySettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientPortalVisibilitySettingsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateRequirementClientPortalVisibility(id: string, updates: ClientPortalVisibilityUpdateDto[]): Observable<void> {
        let url_ = this.baseUrl + "/AyaNova/compliance/Facilities/{id}/client-portal-visibility";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updates);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRequirementClientPortalVisibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRequirementClientPortalVisibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRequirementClientPortalVisibility(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    copyRequirements(id: number, copyToFacilityIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/AyaNova/compliance/Facilities/{id}/copy-requirements";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(copyToFacilityIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyRequirements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyRequirements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCopyRequirements(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchFacilities(name: string | null | undefined): Observable<KeyValueDto[]> {
        let url_ = this.baseUrl + "/AyaNova/compliance/Facilities/search?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchFacilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchFacilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueDto[]>;
        }));
    }

    protected processSearchFacilities(response: HttpResponseBase): Observable<KeyValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValueDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocDueDate(id: number): Observable<FacilityDocDueDatesDto> {
        let url_ = this.baseUrl + "/AyaNova/compliance/Facilities/{id}/doc-due-date";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocDueDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocDueDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityDocDueDatesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityDocDueDatesDto>;
        }));
    }

    protected processGetDocDueDate(response: HttpResponseBase): Observable<FacilityDocDueDatesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FacilityDocDueDatesDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateDocDueDate(id: number, docDueDate: DocDueDateDto): Observable<void> {
        let url_ = this.baseUrl + "/AyaNova/compliance/Facilities/{id}/doc-due-date";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(docDueDate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDocDueDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDocDueDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDocDueDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateCompleteStatus(id: number, facility: ComplianceFacilityDto): Observable<void> {
        let url_ = this.baseUrl + "/AyaNova/compliance/Facilities/{id}/complete-status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(facility);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompleteStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompleteStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCompleteStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateBulkCompleteStatus(bulkEdit: ComplianceFacilityBulkEditDto): Observable<void> {
        let url_ = this.baseUrl + "/AyaNova/compliance/Facilities/bulk-complete-status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkEdit);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBulkCompleteStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBulkCompleteStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBulkCompleteStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAutoMatchSettings(id: number): Observable<FacilityAutoMatchSettingsViewModel> {
        let url_ = this.baseUrl + "/AyaNova/compliance/Facilities/{id}/automatch-settings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAutoMatchSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAutoMatchSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityAutoMatchSettingsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityAutoMatchSettingsViewModel>;
        }));
    }

    protected processGetAutoMatchSettings(response: HttpResponseBase): Observable<FacilityAutoMatchSettingsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FacilityAutoMatchSettingsViewModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateAutoMatchSettings(settings: FacilityAutoMatchSettingsDto): Observable<void> {
        let url_ = this.baseUrl + "/AyaNova/compliance/Facilities/automatch-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAutoMatchSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAutoMatchSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAutoMatchSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkLabRequestConfigurationExistsForFacilities(facilityIds: number[]): Observable<boolean> {
        let url_ = this.baseUrl + "/AyaNova/compliance/Facilities/check-configurations-facilities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(facilityIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckLabRequestConfigurationExistsForFacilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckLabRequestConfigurationExistsForFacilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckLabRequestConfigurationExistsForFacilities(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}